import { addIdeaToDeck, decksLoader, deckLoader } from "../apiCalls"
import { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

function AddToDeckComp(props) {
    const idea = props.mods.idea
    const setAddToDeckToggle = props.mods.setAddToDeckToggle

    const [decks, setDecks] = useState([])
    const [deckSelected, setDeckSelected] = useState(false)
    const [selectedDeck, setSelectedDeck] = useState({})
    const [noDeckSelect, setNoDeckSelect] = useState(false)
    const [alreadyAdded, setAlreadyAdded] = useState(false)


    async function getDecks() {
        let myDecks = await decksLoader()
        setDecks(myDecks)
    }

    useEffect(() => {
        getDecks()
    }, [])

    function handleChange(e) {
        if (e.target.value) {
            getDeck(e.target.value)
        }
    }

    async function getDeck(id) {
        const myDeck = await deckLoader(id)
        setSelectedDeck(myDeck)
        setDeckSelected(true)
    }

    const handleSubmit = async (e) => {
        try{
            e.preventDefault()
            if (deckSelected){
                if (selectedDeck.ideas.includes(idea._id)) {
                    handleAlreadyAdded()
                } else {
                    await addIdeaToDeck(selectedDeck._id, idea._id)
                    getDeck(selectedDeck._id)
                    getDecks()
                }
            } else {
                e.target.reset()
                handleNoSelection()
            }
        } catch(err) {
            console.log(err)
        }
    }

    function handleClose() {
        setAddToDeckToggle(false)
    }

    function buildDeckList() {
        let deckList = decks.map((value, idx) => {
            return (
                <option key={idx} value={value._id}>{value.name}</option>
            )
        })
        return deckList
    }

    function handleNoSelection() {
        setNoDeckSelect(true)
        setTimeout(() => {
            setNoDeckSelect(false)
        }, 2000)
    }

    function handleAlreadyAdded() {
        setAlreadyAdded(true)
        setTimeout(() => {
            setAlreadyAdded(false)
        }, 2000)
    }


    return (

        <div className="newDateContainer">
            <i className="bi bi-x-square closeIcon" onClick={handleClose}></i>
            <Container>
                <h2>Add "{idea.name}" To Deck</h2>
                {(decks.length > 0) ? 
                <Form onSubmit={handleSubmit}>
                <Row>
                <Form.Select name="_id" onChange={handleChange} aria-label="Default select example">
                    <option value="">Select a Deck</option>
                    {buildDeckList()}
                </Form.Select>
                </Row>
                <Row className="inputButtonRow mt-2">
                    {noDeckSelect ? <p>Select a deck first!</p> : alreadyAdded ? <p>This idea is already in that deck!</p> :
                    <Col className="d-flex justify-content-center">
                        <Button variant="dark" type="submit" className="defaultButton deckButton">Submit</Button>
                    </Col>}
                </Row>
                </Form> : <h3>No Decks Available. Make one on the Decks tab!</h3>}
            </Container>
        </div>
    )

}

export default AddToDeckComp